export default __webpack_public_path__ + "static/rovo-menu-light-927f5980f440f81eada32b620bafca7f.png";